module.exports = __webpack_public_path__ + "static/media/lfront.1155b28d.png";